import React, { Component } from 'react'
import { Toolbar, ToolbarGroup, ToolbarTitle } from 'material-ui/Toolbar';
import RaisedButton from 'material-ui/RaisedButton';
import moment from 'moment';
import { Card } from 'material-ui/Card';
import Divider from 'material-ui/Divider';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import TextField from 'material-ui/TextField';
import _ from 'lodash';
import Pagination from 'materialui-pagination';
import DatePicker from 'material-ui/DatePicker';

import * as DataAPI from "../../../common/DataAPI.js";
import DepositDialog from './DepositDialog';
import Dialogs from "../../../common/Dialogs.js";
import constants from "../../../common/constants.js";
import AccountSmsTransactionsList from "./AccountSmsTransactionsList.js"
import AccountDepositTransactionsList from "./AccountDepositTransactionsList.js"
import { TableRowColumn } from "material-ui/Table";
import Subheader from 'material-ui/Subheader';

const partitionByStyles = {
  radioButtonGroup: {
    display: 'inline-flex',
  },
  radioButton: {
    width: 100,
  },
};

const MONTHLY_SELECTION_START = moment().year(2020).month(0).startOf('month');

class Account extends Component {
  constructor() {
    super();
    this.state = {
      account: null,
      smsCost: '',
      accountSmsTransactions: [],
      accountDepositTransactions: [],
      shouldOpenDepositDialog: false,
      totalNoOfAccounts: undefined,
      partitionBy: 'day',
      startDate: null,
      endDate: null,
      monthSelections: [],
      isLoadingForSmsFetch: false,
      isLoadingForDepositFetch: false,
    };

    this.openDepositDialog = this.openDepositDialog.bind(this);
    this.closeDepositDialog = this.closeDepositDialog.bind(this);
    this.submitDeposit = this.submitDeposit.bind(this);
    this.onPartitionByChange = this.onPartitionByChange.bind(this);
    this.updateDataState = this.updateDataState.bind(this);
    this.fetchAccountSmsTransactions = this.fetchAccountSmsTransactions.bind(this);
    this.clearDate = this.clearDate.bind(this);
    this.fetchAccountDepositTransactions = this.fetchAccountDepositTransactions.bind(this);
    this.fetchAccount = this.fetchAccount.bind(this);
  }

  componentWillMount() {
    const noOfMonths = moment().startOf('month').diff(MONTHLY_SELECTION_START, 'months');
    const monthSelections = _.reverse(_.map(_.range(noOfMonths + 1), (noOfMonthToAdd) => {
      return moment(MONTHLY_SELECTION_START).add(noOfMonthToAdd, 'months');
    }));

    this.setState({
      monthSelections,
    });
    this.fetchAccount();
  }

  openDepositDialog() {
    this.setState({
      shouldOpenDepositDialog: true,
    });
  }

  closeDepositDialog() {
    this.setState({
      shouldOpenDepositDialog: false,
    });
  }

  submitDeposit(amount) {
    DataAPI.put(`/api/adminPanel/accountDepositTransaction`, {
      amount,
    }, (err) => {
      if (err) return this.dialogs.error(err);

      this.fetchAccountDepositTransactions();
      this.fetchAccount();
      this.closeDepositDialog();
    });
  }

  clearDate() {
    this.setState({
      startDate: null,
      endDate: null,
    });
  }

  onPartitionByChange(event, value) {
    this.setState({
      partitionBy: value,
    });

    this.clearDate();
  }

  updateDataState(field, newDate) {
    this.setState({
      [field]: newDate,
    });
  }

  fetchAccountSmsTransactions() {
    this.setState({
      isLoadingForSmsFetch: true,
      accountSmsTransactions: [],
    }, () => {
      DataAPI.get(`/api/adminPanel/accountSmsTransactions/`, {
        startDate: moment(this.state.startDate).utc().format(),
        endDate: moment(this.state.endDate).utc().format(),
        partitionBy: this.state.partitionBy,
      }, (err, accountSmsTransactions) => {
        this.setState({ isLoadingForSmsFetch: false });

        if (err) return this.dialogs.error(err);

        this.setState({ accountSmsTransactions });
      });
    });
  }

  fetchAccountDepositTransactions() {
    this.setState({
      isLoadingForDepositFetch: true,
      accountDepositTransactions: [],
    }, () => {
      DataAPI.get(`/api/adminPanel/accountDepositTransactions/`, {}, (err, accountDepositTransactions) => {
        this.setState({ isLoadingForDepositFetch: false });

        if (err) return this.dialogs.error(err);

        this.setState({ accountDepositTransactions });
      });
    });
  }

  fetchAccount() {
    DataAPI.get(`/api/adminPanel/account`, {}, (err, result) => {
      if (err) return this.dialogs.error(err);

      const { account, smsCost } = result;

      this.setState({ account, smsCost });
    });
  }

  render() {
    const wrapOnChange = (fnc, field, event, value) => {
      fnc(field, value);
    };

    const wrapSelectFieldOnChange = (fnc, field, event, index, value) => {
      fnc(field, value);
    };

    const wrapDatePickerOnChange = (fnc, field, alwaysNull, value) => {
      fnc(field, value);
    };

    return (
      <div className="account-block">
        <Toolbar>
          <ToolbarGroup>
            <ToolbarTitle
              text="SMS帳戶" />
          </ToolbarGroup>
          <ToolbarGroup
            lastChild={true}>
            {
              constants.hvPermission(['canAddDeposit']) &&
                <RaisedButton
                  label="新增存款"
                  primary={true}
                  icon={<i className="material-icons md-light">add</i>}
                  onClick={this.openDepositDialog} />
            }
          </ToolbarGroup>
        </Toolbar>

        <div className="top-bar-block">
          <div className="balance-block">
            <div className="title">餘額</div>
            <div className="value">${_.get(this.state.account, 'balance', '')}</div>
          </div>


          <div className="cost-per-sms-block">
            <div className="title">每個SMS成本</div>
            <div className="value">${this.state.smsCost || ''}</div>
          </div>
        </div>

        <Subheader style={{
          backgroundColor: '#e8e8e8',
          marginTop: 20,
          height: 48,
        }}>
          <div style={{
            float: 'left',
          }}>存款記錄
          </div>
          <RaisedButton
            label="顯示"
            primary={true}
            style={{
              marginTop: 6,
              marginRight: 16,
              float: 'right',
            }}
            disabled={this.state.isLoadingForDepositFetch}
            onClick={this.fetchAccountDepositTransactions} />
        </Subheader>


        <AccountDepositTransactionsList
          accountDepositTransactions={this.state.accountDepositTransactions}
          isLoadingForDepositFetch={this.state.isLoadingForDepositFetch} />


        <Subheader style={{
          backgroundColor: '#e8e8e8',
          marginTop: 20,
        }}>發送記錄</Subheader>

        <div className="partition-by-block">
          <div className="title">劃分時間</div>
          <RadioButtonGroup
            name="partitionBy"
            defaultSelected="day"
            valueSelected={this.state.partitionBy}
            style={partitionByStyles.radioButtonGroup}
            onChange={this.onPartitionByChange}>
            <RadioButton
              value="day"
              label="天"
              style={partitionByStyles.radioButton}
            />
            <RadioButton
              value="month"
              label="月"
              style={partitionByStyles.radioButton}
            />
          </RadioButtonGroup>
        </div>

        <div className="date-range-block">
          <div className="title">時間範圍</div>

          {
            this.state.partitionBy === 'day' &&
            <div className="date-picker-block">
              <DatePicker
                hintText="開始"
                container="inline"
                defaultDate={this.state.startDate}
                onChange={wrapDatePickerOnChange.bind(this, this.updateDataState, 'startDate')}
                value={this.state.startDate}
                DateTimeFormat={global.Intl.DateTimeFormat}
                firstDayOfWeek={0}
                locale="zh-HK"
                okLabel="確定"
                cancelLabel="取消"
                textFieldStyle={{
                  width: 150,
                }}
                style={{
                  float: 'left',
                }}
              />
              <div className="middle-line"> -</div>
              <DatePicker
                hintText="結束"
                container="inline"
                defaultDate={this.state.endDate}
                onChange={wrapDatePickerOnChange.bind(this, this.updateDataState, 'endDate')}
                value={this.state.endDate}
                DateTimeFormat={global.Intl.DateTimeFormat}
                firstDayOfWeek={0}
                locale="zh-HK"
                okLabel="確定"
                cancelLabel="取消"
                textFieldStyle={{
                  width: 150,
                }}
                style={{
                  float: 'left',
                  marginLeft: 10,
                }}
              />
            </div>
          }
          {
            this.state.partitionBy === 'month' &&
            <div className="month-selections-block">
              <SelectField
                hintText="開始"
                style={{
                  float: 'left',
                  width: 150,
                  textAlign: 'center',
                }}
                value={this.state.startDate}
                onChange={wrapSelectFieldOnChange.bind(this, this.updateDataState, 'startDate')}
              >
                {
                  _.map(this.state.monthSelections, (date, index) => (
                    <MenuItem key={index} value={moment(date).toISOString()}
                              primaryText={moment(date).format('MM/YYYY')} />
                  ))
                }
              </SelectField>
              <div className="middle-line"> -</div>
              <SelectField
                hintText="結束"
                style={{
                  width: 150,
                  textAlign: 'center',
                  marginLeft: 10,
                }}
                value={this.state.endDate}
                onChange={wrapSelectFieldOnChange.bind(this, this.updateDataState, 'endDate')}
              >
                {
                  _.map(this.state.monthSelections, (date, index) => (
                    <MenuItem key={index} value={moment(date).toISOString()}
                              primaryText={moment(date).format('MM/YYYY')} />
                  ))
                }
              </SelectField>
            </div>
          }
        </div>

        <RaisedButton
          label="搜尋"
          primary={true}
          style={{
            marginTop: 10,
          }}
          disabled={this.state.isLoadingForSmsFetch || !this.state.startDate || !this.state.endDate}
          onClick={this.fetchAccountSmsTransactions} />


        <AccountSmsTransactionsList accountSmsTransactions={this.state.accountSmsTransactions}
                                    isLoadingForSmsFetch={this.state.isLoadingForSmsFetch} />

        <DepositDialog
          open={this.state.shouldOpenDepositDialog}
          handleClose={this.closeDepositDialog}
          handleSubmit={this.submitDeposit} />
        <Dialogs onInit={dialog => (this.dialogs = dialog)} />
      </div>
    )
  }
}

export default Account;


// WEBPACK FOOTER //
// client/adminPanel/panel/accounts/Account.js